module.exports = __webpack_public_path__ + "0d89deaed5fb33cfca835f8638d43b2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/quanta_services_2023_chart.png
// module id = 1716
// module chunks = 0